export const APEX_MODULE = 'apex_module'
export const AMENITY_ID = 'amenity_id'
export const AMOUNT = 'amount'
export const START_DATETIME = 'start_datetime'
export const END_DATETIME = 'end_datetime'
export const AMENITY = 'amenity'
export const MOVEIN = 'movein'
export const MOVEIN_ID = 'movein_id'